module.exports = __webpack_public_path__ + "static/img/coner5.d6cae05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/coner5.png
// module id = zwCz
// module chunks = 1